import { writable, readable } from 'svelte/store';
import * as app from "./app.json5";
import * as ciDef from "../public/ci/gamechanger/gamechanger.json5"

const setToString = (set) => {
  if (set === null) return null;
  return JSON.stringify([...set]);
}
const stringToSet = (str) => {
  if (str === null) return null;
  return new Set(JSON.parse(str));
}

const saveId = app["save_id"] ? app.save_id : "generic";
export const saveKey = `locked-app-${saveId}-storage`
const storedFlags = stringToSet(localStorage.getItem(`${saveKey}_flags`));
const storedBenefits = stringToSet(localStorage.getItem(`${saveKey}_benefits`));
const storedNewestSection = localStorage.getItem(`${saveKey}_newest_section`);

export const flags = writable(storedFlags || new Set());
flags.subscribe((value) => {
  localStorage.setItem(`${saveKey}_flags`, setToString(value))
})
export const benefits = writable(storedBenefits || new Set());
benefits.subscribe((value) => {
  localStorage.setItem(`${saveKey}_benefits`, setToString(value))
})
export const newestSection = writable(storedNewestSection || null);
newestSection.subscribe((value) => {
  localStorage.setItem(`${saveKey}_newest_section`, value)
})


export const sections = readable(app["sections"]);
export const benefitsDef = readable(app["benefits"]);
export const ci = writable(ciDef);
export const debug = readable(app["debug"]);

import Zooming from "zooming";
export const zooming = readable(new Zooming({
  scaleExtra: 1.66,
}));
